import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from '../store/ordersSlice.js';
import { useNavigate } from "react-router-dom";

const CompletedOrders = () => {
  const dispatch = useDispatch();
  const orders = useSelector((s) => s.orders.items || []);
  const user = useSelector((s) => s.auth.user);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch]);

  const completedOrders = orders.filter(
    (o) => o.status === "completed" || o.status === "delivered",
  );

  if (!user) {
    navigate("/signin");
    return null;
  }

  return (
    <div className="py-5" style={{ background: "#f8f9fa", minHeight: "100vh" }}>
      <div className="container">
        <h1 className="fw-bold mb-2">Completed Orders</h1>
        <p className="text-muted mb-5">
          Orders that have been delivered to you
        </p>

        {completedOrders.length === 0 ? (
          <div className="card border-0 shadow-sm rounded-4 p-5 text-center">
            <h5 className="text-muted">No completed orders yet</h5>
            <p className="text-muted small">
              Your delivered orders will appear here
            </p>
          </div>
        ) : (
          <div className="row g-3">
            {completedOrders.map((order) => (
              <div key={order.id} className="col-md-6 col-lg-4">
                <div className="card border-0 shadow-sm rounded-4 p-4">
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <p className="text-muted small mb-1">Order ID</p>
                      <h6 className="fw-bold">{order.id?.slice(0, 8)}</h6>
                    </div>
                    <span className="badge bg-success">DELIVERED</span>
                  </div>

                  <hr className="my-3" />

                  <div className="mb-3">
                    <p className="text-muted small mb-1">Customer</p>
                    <p className="fw-bold">{order.name}</p>
                  </div>

                  <div className="mb-3">
                    <p className="text-muted small mb-1">Items</p>
                    <p className="fw-bold">
                      {order.items?.length || 0} item(s)
                    </p>
                  </div>

                  <div className="mb-3">
                    <p className="text-muted small mb-1">Total Amount</p>
                    <h5 className="fw-bold">₹{order.total?.toFixed(2)}</h5>
                  </div>

                  <div className="mb-3">
                    <p className="text-muted small mb-1">Delivery Address</p>
                    <p className="small">
                      {order.address}, {order.city}, {order.state} -{" "}
                      {order.pincode}
                    </p>
                  </div>

                  <div className="mb-3">
                    <p className="text-muted small mb-1">Phone</p>
                    <p className="small">{order.phone}</p>
                  </div>

                  <div className="mb-3">
                    <p className="text-muted small mb-1">Delivered On</p>
                    <p className="small">
                      {order.createdAt
                        ? new Date(order.createdAt).toLocaleDateString()
                        : "—"}
                    </p>
                  </div>

                  {/* PROGRESS BAR */}
                  <div className="mt-4">
                    <div className="progress" style={{ height: "6px" }}>
                      <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: "100%" }}
                      ></div>
                    </div>
                    <p className="text-muted small mt-2 mb-0">
                      ✓ Successfully delivered
                    </p>
                  </div>

                  <button className="btn btn-outline-dark w-100 mt-3 rounded-3">
                    <i className="bi bi-arrow-repeat me-2"></i>Reorder
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompletedOrders;
